module.exports = __webpack_public_path__ + "media/images/places/img_kaihikon-a5781e9df3f9b350b3ecc456ba88ab0e.jpg";